import floor from 'lodash/floor';

export const calculateUserInSegmentOfTotal = (total: number, usersInSegment: number) => {
  // Avoid NaN values when total is 0

  if (total === 0) return 0;

  const usersInSegmentOfTotal = usersInSegment / total || 0;
  const percent = usersInSegmentOfTotal * 100;

  const percentage = floor(percent, 2);
  if (percentage >= 100) return 100;

  return percentage;
};

export default calculateUserInSegmentOfTotal;
